import {JSX} from "react";

import {Typography} from "@/shared/ui/data-display/typography";

interface PopularPostsHeaderProps {
    title: string;
}

export function PopularPostsHeader({title}: PopularPostsHeaderProps): JSX.Element {
    return (
        <div className="popular-posts__header">
            <Typography as="h2" size={{desktop: 20, mobile: 20}} weight={500} className="popular-posts__title">
                {title}
            </Typography>
        </div>
    );
}
